import idb from "@/plugins/indexdb.js";
import LowerLimbRepo from "@/repositories/products/lowerLimbRepository";

import lowerLimbDefaultForm from "./forms/lowerLimb";

export default {
  namespaced: true,

  state: {
    lowerLimb: lowerLimbDefaultForm
  },

  mutations: {
    SET_LOWER_LIMB(state, payload) {
      state.lowerLimb = Object.assign({}, state.lowerLimb, payload);
    },

    RESET_LOWER_LIMB(state) {
      state.lowerLimb = lowerLimbDefaultForm;
    }
  },
  actions: {
    /**
     * Get lower limb product by uuid
     *
     * @param {String} lower_limb_uuid Lower limb uuid
     */
    async get({ commit }, lower_limb_uuid) {
      try {
        const { data } = await LowerLimbRepo.get(lower_limb_uuid);
        commit("SET_LOWER_LIMB", data);
        return data;
      } catch (error) {
        throw error;
      }
    },

    // Create a new lower limb
    async createLowerLimb(context, payload) {
      try {
        const { data } = await LowerLimbRepo.createLowerLimb(payload);
        return data;
      } catch (error) {
        throw error;
      }
    },

    /**
     * Local part
     */

    /**
     * Get lower limb product from IndexedDB
     *
     * @param {String} lower_limb_uuid Lower limb uuid
     */
    async getFromLocal({ commit }, lower_limb_uuid) {
      const lowerLimb = await idb.db.lower_limb.get(lower_limb_uuid);

      // If not found return null
      if (!lowerLimb) return null;

      commit("SET_LOWER_LIMB", lowerLimb);

      return lowerLimb;
    },

    // Reset lower limb
    resetProduct({ commit }) {
      commit("RESET_LOWER_LIMB");
    }
  }
};
